export default __webpack_public_path__ + "static/media/serviceflowmobile.a1825843.svg";